export default "__VITE_ASSET__SAe2shae__"